const crop_list = {
	apricot_tree: String("ALBARICOQUERO"),
	aubergine: String("BERENJENA"),
	basil: String("ALBACA"),
	alfalfa: String("ALFALFA"),
	other_fruit_trees: String("OTROS FRUTALES"),
	almond_trees: String("ALMENDROS"),
	anethum_graveolens: String("ENELDO"),
	celery: String("APIO"),
	rice: String("ARROZ"),
	hazelnut_tree: String("AVELLANO"),
	corn: String("MAÍZ"),
	durum_wheat: String("TRIGO DURO"),
	khorasan_wheat: String("TRIGO KHORASAN"),
	soft_wheat: String("TRIGO BLANDO"),
	swiss_chard: String("ACELGAS"),
	common_marigold: String("CALENDULA"),
	mushrooms: String("SETAS"),
	borage: String("BORRAJA"),
	hemp: String("CÁÑAMO"),
	peanut: String("CACAHUETE"),
	camomile: String("MANZANILLA"),
	camelina: String("CAMELINA"),
	common_cane: String("CAÑA COMÚN"),
	khaki: String("CAQUI"),
	pumkpin: String("CALABAZA"),
	zucchini: String("CALABACIN"),
	artichoke: String("ALCACHOFA"),
	chestnut_tree: String("CASTAÑO"),
	onions_garlick: String("CEBOLLA"),
	chickpea: String("GARBANZOS"),
	cherry_tree: String("CEREZO"),
	oat: String("AVENA"),
	clementine: String("CLEMENTINA"),
	quince_tree: String("MEMBRILLO"),
	cucumber: String("PEPINO"),
	cabbage_and_coliflower: String("COL Y COLIFLOR"),
	colza: String("COLZA"),
	coriander: String("CILANTRO"),
	watercress: String("BERRO"),
	tail_of_rat: String("FLEO"),
	date: String("DATIL"),
	lettuce: String("LECHUGA"),
	endive_chicory: String("ENDIVIA"),
	erbs: String("YEROS"),
	canary_grass: String("ALPISTE"),
	asparagus: String("ESPARRAGOS"),
	aromatic_herbs: String("ESPECIAS AROMATICAS HERBACEAS"),
	woody_aromatiques: String("ESPECIES AROMÁTICAS LEÑOSAS"),
	spelt: String("ESPELTA"),
	spinach: String("ESPINACA"),
	buckwheat: String("ALFORFON"),
	thyme: String("TOMILLO"),
	moreu: String("ALBERJON"),
	beans: String("HABAS"),
	fenugreek: String("FENOGRECO"),
	festuca: String("FESTUCA"),
	fig_tree: String("HIGUERA"),
	flowers_and_ornamental: String("FLORES Y ORNAMENTALES"),
	fennel: String("HINOJO"),
	fruit_trees: String("FRUTALES VARIOS"),
	green_pea: String("ALVERJA"),
	carob_tree: String("ALGARROBO"),
	blueberry: String("ARANDANOS"),
	sunflower: String("GIRASOL"),
	redcurrant: String("GROSELLA"),
	lying_fallow: String("BARBECHO"),
	lathyrus_sativus: String("ALMORTA"),
	hyssop: String("HISOPO"),
	orchard: String("HUERTO"),
	parsley: String("PEREJIL"),
	kiwi: String("KIWI"),
	lavender: String("LAVANDA"),
	hop: String("LUPULO"),
	lentils: String("LENTEJAS"),
	linen: String("LINO"),
	lemons: String("LIMONERO"),
	strawberry: String("FRESA"),
	pomegranate_tree: String("GRANADO"),
	mandarin_tree: String("MANDARINO"),
	marjoram: String("MEJORANA"),
	melon: String("MELON"),
	orange_blossom: String("AZAHAR"),
	mint: String("MENTA"),
	mestall: String("TRANQUILLON"),
	mill: String("MIJO"),
	alt_beans_1: String("ALUBIA"),
	blueberrys: String("ARANDANOS"),
	chinese_turnip_and_cabbage: String("NABO Y COL CHINA"),
	nashi: String("NASHI"),
	nectarine_tree: String("NECTARINA"),
	medlar: String("NISPERO"),
	walnut_trees: String("NOGALES"),
	olive_trees: String("OLIVOS"),
	barley: String("CEBADA"),
	oregano: String("ORÉGANO"),
	pea_and_oat: String("GUISANTE Y AVENA"),
	peas_and_barley: String("GUISANTE Y CEBADA"),
	peas: String("GUISANTES"),
	carrot: String("ZANAHORIA"),
	potato: String("PATATA"),
	pepper: String("PIMIENTO"),
	pear_trees: String("PERALES"),
	pear_apple_tree: String("PERALES/MANZANOS"),
	hypericum_or_saint_johns_wort: String("HIPERICO O HIERBA DE SAN JUAN"),
	pistachio: String("PISTACHO"),
	bread_poa: String("POA"),
	grapefruit: String("POMELO"),
	apple_trees: String("MANZANOS"),
	peach_trees: String("MELOCOTONEROS"),
	peach_nectarine_tree: String("MELOCOTONERO/NECTARINOS"),
	plum_tree: String("CIRUELO"),
	quinoa: String("QUINOA"),
	grape: String("UVA DE MESA"),
	radish: String("RÁBANO"),
	ray_grass: String("RAYGRAS"),
	beetroot: String("REMOLACHA"),
	rosemary: String("ROMERO"),
	rye: String("CENTENO"),
	watermelon: String("SANDIA"),
	saffron: String("AZAFRÁN"),
	sajolida: String("AJEDREA"),
	satsuma_tangerine: String("SATSUMAS"),
	soy: String("SOJA"),
	sorghum: String("SORGO"),
	sulla: String("ZULLA"),
	truffle: String("TRUFA"),
	tobacco: String("TABACO"),
	orange_tree: String("NARANJO"),
	tomato: String("TOMATE"),
	clover: String("TRÉBOL"),
	sweet_lupine: String("ALTRAMUZ DULCE"),
	sainfoin: String("ESPARCETA"),
	triticale: String("TRITICALE"),
	tritordeum: String("TRITORDEUM"),
	vetch_and_wheat: String("VEZA Y TRIGO"),
	vetch_and_oat: String("VEZA Y AVENA"),
	efa_vetch_and_barley: String("VEZA Y CEBADA"),
	efa_vetch_and_triticale: String("VEZA Y TRITICALE"),
	vetch: String("VEZAS"),
	vineyards: String("VIÑAS"),
	nursery_tree_and_shrub: String("VIVEROS"),
};

export default crop_list;